import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const appointmentApi = createApi({
  reducerPath: "appointmentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}/appointments/`,
    prepareHeaders: (headers, { getState }) => {
      const cookies = document.cookie.split(";");
      let jwtCookie = null;

      cookies.forEach((cookie) => {
        const trimmedCookie = cookie.trim();
        if (trimmedCookie.startsWith("token=")) {
          jwtCookie = "Bearer " + trimmedCookie.split("token=")[1];
        }
      });

      if (jwtCookie) {
        headers.set("authorization", jwtCookie);
      }

      return headers;
    },
  }),
  tagTypes: ['Appointments'],
  endpoints: (builder) => ({
    setHolisdays: builder.mutation({
      query: (body) => ({
        url: `set-holidays`,
        method: "POST",
        body: body,
      }),
    }),
    setAvailability: builder.mutation({
      query: (body) => ({
        url: `set-availability`,
        method: "post",
        body: body,
      }),
    }),
    availability: builder.query({
      query: (body) => ({
        url: `availability/${body.userId}`,
        method: "GET",
      }),
    }),
    createAppointment: builder.mutation({
      query: (body) => ({
        url: `appointment-booking`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ['Appointments'],
    }),

    requestAppointment: builder.mutation({
      query: (body) => ({
        url: `request-appointment`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ['Appointments'],
    }),

    cancelRequestedAppointment: builder.mutation({
      query: (id) => ({
        url: `cancel-requested-appointment/${id}`,
        method: "POST"
      }),
      invalidatesTags: ['Appointments'],
    }),

    markRequestedAppointmentAsSchedule: builder.mutation({
      query: ({id, ...body}) => ({
        url: `mark-requested-appointment-as-schedule/${id}`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ['Appointments'],
    }),
    appointments: builder.query({
      query: (body) => ({
        url: `appointments-list`,
        method: "GET",
        params: body,
      }),
      providesTags: ['Appointments'],
    }),
    upcomingAppointmentReps: builder.query({
      query: (body) => ({
        url: `appointments-list/rep/${body.repId}/${body.userId}`,
        method: "GET",
      }),
    }),
    holidays: builder.query({
      query: (id) => {
        if (!id) throw new Error("ID is required");
        return {
          url: `holidays-list?repId=${id}`,
          method: "GET",
        };
      },
    }),
    checkActionToken: builder.mutation({
      query: ({ action, token }) => ({
        url: `check-action-token/${action}`,
        method: "POST",
        body: { token },
      }),
    }),
  }),
});

export const {
  useSetAvailabilityMutation,
  useRequestAppointmentMutation,
  useCancelRequestedAppointmentMutation,
  useMarkRequestedAppointmentAsScheduleMutation,
  useSetHolisdaysMutation,
  useCreateAppointmentMutation,
  useAppointmentsQuery,
  useUpcomingAppointmentRepsQuery,
  useHolidaysQuery,
  useAvailabilityQuery,
  useCheckActionTokenMutation,

} = appointmentApi;
